export default "__VITE_PUBLIC_ASSET__4cbabd4f__"